import { render, staticRenderFns } from "./upairy-timeline.vue?vue&type=template&id=5cf1cc0b&scoped=true&"
import script from "./upairy-timeline.vue?vue&type=script&lang=js&"
export * from "./upairy-timeline.vue?vue&type=script&lang=js&"
import style0 from "./upairy-timeline.vue?vue&type=style&index=0&id=5cf1cc0b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cf1cc0b",
  null
  
)

export default component.exports